
import React from 'react';
import { Box } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';

const OrderItem = ({ label, value, primary }) => (
  <Box mb={4}>
    <p sx={{ margin: 0, color: 'label' }}>{label}</p>
    <Themed.h5 sx={{ margin: 0, color: primary ? 'primary' : '' }}>
      {value}
    </Themed.h5>
  </Box>
);

const orderSummary = ({ vm }) => {
  return (
    <Box>
      <Themed.h4 sx={{ marginTop: 0 }}>Užsakymo informacija</Themed.h4>

      {vm.product && <OrderItem label="Paslauga:" value={vm.product} />}
      {vm.subject && <OrderItem label="Dalykas:" value={vm.subject} />}
      {vm.class && vm.class.length > 0 && (
        <OrderItem label="Klasė:" value={vm.class} />
      )}
      {vm.details && (
        <OrderItem
          label="Formatas / Trukmė / Puslapių sk.:"
          value={vm.details}
        />
      )}
      {vm.price && (
        <OrderItem label="Mokėtina suma:" value={vm.price} primary />
      )}
    </Box>
  );
};

export default orderSummary;
